import type { Router } from 'vue-router'

let activeRouter: Router | null = null

export const setActiveRouter = (router: Router) => {
  activeRouter = router
}

export const getActiveRouter = () => activeRouter
